import styled from "styled-components";
import { breakpoints } from "../../../../shared-logic/themes/toyotaTheme";

export const Wrapper = styled.div`
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    flex-direction: column;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    box-shadow:
        0px -0.68px 3.62304px 0px rgba(0, 0, 0, 0.02),
        0px -1.88px 10.01724px 0px rgba(0, 0, 0, 0.03),
        0px -4.52px 24.11766px 0px rgba(0, 0, 0, 0.05),
        0px -15px 80px 0px rgba(0, 0, 0, 0.04);
    z-index: var(--z-index-sticky);

    @media screen and (min-width: ${breakpoints.xl}) {
        display: none;
    }
`;

export const Body = styled.div`
    display: flex;
    background-color: var(--color-primary-white);
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    & > button {
        flex: 1 0 100%;
    }

    &:not(:empty) {
        padding: var(--spacing-2);
    }
`;

export const Toggle = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--spacing-2) var(--spacing-2);
    color: var(--color-primary-black);
    background-color: var(--color-grey-1);
    border-top: 1px solid var(--color-grey-4);
`;
